import Card from '../card';

/**
 * The AboutWeatherStation component is used on the About page to show information about
 * the weather station.
 *
 * props: none
 */

const AboutWeatherStation = () => (
	<Card cardTitle="Weather station">
		<p>The weather station is a wireless Davis Vantage Pro 2 unit, located in the western part of the Howick area. Howick
			is an eastern suburb of Auckland, New Zealand. The station was set up in early December of 2009.
		</p>

		<p>The weather station is comprised of 3 parts: the indoor console, the anemometer (for wind speed and direction),
			and ISS (Integrated Sensor Suite). The ISS combines the rain gauge, temperature and humidity sensors into a single unit.
			The temperature and humidity sensors are housed within a durable fan-aspirated solar radiation shield in order to
			maximise accuracy. I spent some considerable time early in the weather station's early history calibrating the rain gauge
			to try get the readings as accurate as I can. Both the anemometer and the ISS transmit their data to the indoor console, which is
			connected to a PC by USB cable.
		</p>

		<p>The data sent to the PC is continuously monitored by <a href="https://cumuluswiki.wxforum.net/a/About_Cumulus">Cumulus</a>,
			which stores all data received and keeps track of all the daily extremes and weather station records. Cumulus
			uploads live data to the website at regular intervals.
		</p>
	</Card>
);

export default AboutWeatherStation;



// WEBPACK FOOTER //
// ./components/about/about-weather-station.js